<div class="avatar-manager-container">
  <div [class.has-preview]="previewUrl" class="avatar-manager">
    <!-- Hidden file input accessible from both panels -->
    <input
      #fileInput
      [disabled]="loading"
      (change)="onFileSelected($event)"
      class="file-input"
      accept="image/jpeg,image/png"
      type="file"
    />

    <div class="avatar-panel-container">
      <!-- Current avatar panel -->
      <div
        *ngIf="avatarUrl !== defaultAvatarUrl && !isDeletingAvatar && !previewUrl"
        class="avatar-panel current-avatar-panel"
      >
        <div class="avatar-container">
          <img *ngIf="!loading && avatarUrl" [alt]="user?.username" [src]="avatarUrl" class="current-avatar-image" />
          <astrobin-loading-indicator *ngIf="loading" size="medium"></astrobin-loading-indicator>
        </div>
        <div class="avatar-info">
          <h5>{{ "Current avatar" | translate }}</h5>
          <button [disabled]="loading" (click)="deleteAvatar()" class="btn btn-outline-danger btn-sm delete-btn">
            <fa-icon icon="trash"></fa-icon>
            {{ "Delete" | translate }}
          </button>
          <p class="delete-note">
            {{ "Will reset to default" | translate }}
          </p>
          <div class="mt-3">
            <button [disabled]="loading" (click)="fileInput.click()" class="btn btn-primary btn-sm">
              <fa-icon icon="cloud-upload-alt"></fa-icon>
              {{ "Upload new" | translate }}
            </button>
          </div>
        </div>
      </div>

      <!-- Upload panel -->
      <div
        *ngIf="(!avatarUrl || avatarUrl === defaultAvatarUrl || previewUrl) && !isDeletingAvatar"
        class="avatar-panel upload-panel"
      >
        <div class="upload-container">
          <div [class.has-preview]="previewUrl" class="upload-dropzone">
            <ng-container *ngIf="!previewUrl; else previewTemplate">
              <fa-icon class="upload-icon" icon="cloud-upload-alt"></fa-icon>
              <h5>{{ "Upload avatar" | translate }}</h5>
              <p class="upload-note">{{ "Accepted formats: JPEG, PNG" | translate }}</p>
              <div class="upload-actions">
                <button [disabled]="loading" (click)="fileInput.click()" class="btn btn-primary btn-sm browse-btn">
                  <fa-icon icon="folder-open"></fa-icon>
                  {{ "Select file" | translate }}
                </button>
              </div>
            </ng-container>

            <ng-template #previewTemplate>
              <div class="preview-container">
                <div #previewContainer class="preview-image-container">
                  <img #previewImage [src]="previewUrl" (load)="onImageLoad(previewContainer)" class="preview-image" />
                  <div
                    [style.height.px]="circleDiameter"
                    [style.width.px]="circleDiameter"
                    class="avatar-preview-circle"
                  ></div>
                </div>
                <div class="image-transform-controls">
                  <div class="transform-actions">
                    <button
                      [disabled]="loading"
                      (click)="rotateImage()"
                      class="btn btn-outline-secondary btn-sm m-0"
                      title="{{ 'Rotate' | translate }}"
                    >
                      <fa-icon icon="rotate-left"></fa-icon>
                    </button>
                    <button
                      [disabled]="loading"
                      (click)="flipImageHorizontal()"
                      class="btn btn-outline-secondary btn-sm m-0"
                      title="{{ 'Flip horizontally' | translate }}"
                    >
                      <fa-icon icon="arrows-left-right"></fa-icon>
                    </button>
                    <button
                      [disabled]="loading"
                      (click)="flipImageVertical()"
                      class="btn btn-outline-secondary btn-sm m-0"
                      title="{{ 'Flip vertically' | translate }}"
                    >
                      <fa-icon icon="arrows-up-down"></fa-icon>
                    </button>
                  </div>
                </div>
                <div class="preview-footer">
                  <div class="preview-actions">
                    <button
                      [class.loading]="loading"
                      [disabled]="loading"
                      (click)="uploadAvatar()"
                      class="btn btn-success btn-sm m-0"
                    >
                      <fa-icon *ngIf="!loading" icon="check"></fa-icon>
                      <fa-icon *ngIf="loading" [spin]="true" icon="spinner"></fa-icon>
                      {{ loading ? ("Uploading" | translate) : ("Upload" | translate) }}
                    </button>
                    <button
                      [disabled]="loading"
                      (click)="cancelSelection()"
                      class="btn btn-outline-secondary btn-sm m-0"
                    >
                      <fa-icon icon="times"></fa-icon>
                      {{ "Cancel" | translate }}
                    </button>
                  </div>
                  <div *ngIf="selectedFile" class="file-info">
                    <span class="file-name">{{ selectedFile.name }}</span>
                    <span class="file-size">{{ getFileSize(selectedFile.size) }}</span>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Deleting indicator -->
      <div *ngIf="isDeletingAvatar" class="avatar-panel deleting-panel">
        <div class="deleting-container">
          <astrobin-loading-indicator size="large"></astrobin-loading-indicator>
          <p class="mt-3">{{ "Deleting avatar..." | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
